/**
 * AllAll Veo 3.1：接口与参数同 Veo 3，FormData 提交 POST /v1/videos，仅 model 不同
 * 参数：model=veo3.1, prompt, seconds, input_reference(File 必填), size, watermark
 */
function normalizeSeconds(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 8
  if (num <= 4) return 4
  if (num <= 6) return 6
  return 8
}

function normalizeSize(v) {
  var s = (v || '16:9').replace(/：/g, ':').trim()
  return s === '9:16' ? '9x16' : '16x9'
}

/**
 * 构建 AllAll POST /v1/videos 的 FormData（Veo 3.1，仅图片转视频，调用方需保证 referenceImage 为 File）
 * @param {Object} params - prompt, videoDuration?, aspectRatio?, referenceImage(File 必填), watermark?
 */
export function buildFormData(params) {
  var form = new FormData()
  form.append('model', 'veo3.1')
  form.append('prompt', (params.prompt || '').trim().slice(0, 2000))
  form.append('seconds', String(normalizeSeconds(params.videoDuration || params.length || 8)))
  form.append('size', normalizeSize(params.aspectRatio))
  form.append('watermark', params.watermark === true ? 'true' : 'false')
  if (params.referenceImage && typeof File !== 'undefined' && params.referenceImage instanceof File) {
    form.append('input_reference', params.referenceImage, params.referenceImage.name || 'image.jpg')
  }
  return form
}
